// extracted by extract-css-chunks-webpack-plugin
module.exports = {"container":"process-steps__container___Lfdqe","item":"process-steps__item___AmD1B","arrow":"process-steps__arrow___17NS8"};
    if(module.hot) {
      // 1701915839587
      var cssReload = require("../../../../../node_modules/extract-css-chunks-webpack-plugin/dist/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}","cssModules":true});
      module.hot.dispose(cssReload);
      ;
    }
  